import { ConfigBasedSequence } from './configBaseSequence';
import {
  RestForFirstExercise,
  RestForFourthExercise,
  RestForSecondExercise,
  RestForThirdExercise,
  TrainForFirstExercise,
  TrainForFourthExercise,
  TrainForSecondExercise,
  TrainForThirdExercise,
  TransitionForRest,
  TransitionForTrain,
} from './content';
export class BalanceQuad extends ConfigBasedSequence {
  protected configForEachSequenceEntry = () => {
    const timeForRest = {
      bodyweightLite : 10,
      dumbbellsLight: 14,
      equipment: 10,
    };

    const timingForTraining = {
      bodyweightLite : 31,
      dumbbellsLight: 27,
      equipment: 31,
    }

    return [
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForRest(),
      },
      {
        timing: timeForRest,
        content: new RestForFirstExercise(),
      },
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForTrain(),
      },
      {
        timing: timingForTraining,
        content: new TrainForFirstExercise(),
      },
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForRest(),
      },
      {
        timing: timeForRest,
        content: new RestForSecondExercise(),
      },
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForTrain(),
      },
      {
        timing: timingForTraining,
        content: new TrainForSecondExercise(),
      },
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForRest(),
      },
      {
        timing: timeForRest,
        content: new RestForThirdExercise(),
      },
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForTrain(),
      },
      {
        timing: timingForTraining,
        content: new TrainForThirdExercise(),
      },
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForRest(),
      },
      {
        timing: timeForRest,
        content: new RestForFourthExercise(),
      },
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForTrain(),
      },
      {
        timing: timingForTraining,
        content: new TrainForFourthExercise(),
      },
    ];
  }
}
